import React from 'react';
import { Text, Image } from '@sitecore-jss/sitecore-jss-react';
import './style.scss';
import Button from '../Shared/components/controls/Button';
import clsx from 'clsx';

const Offers = (props) => {
  const itemsListing = props?.fields.items;
  return (
    <div className={clsx('container', 'add-margins', props?.params?.Styles)}>
      <div className="deatilHeader">
        <div className="row align-bottom">
          <div className="col-md-9">
            <h2>
              <Text field={props?.fields.heading} />
            </h2>
            <p>
              <Text field={props?.fields.text} />
            </p>
          </div>
          <div className="col-md-3">
          {props?.fields.link.value.text && (<div className="allDealButton">
             
                <Button
                  link={props?.fields.link}
                  arrow="right"
                  variant="contained"
                  color="secondary"
                >
                  {props?.fields.link.value.text}
                </Button>
             
            </div>
             )}
          </div>
        </div>
      </div>
      <div className="row">
        {itemsListing &&
          itemsListing.map((data, index) => {
            console.log("data",data);
            return (
              <div className="col-md-4" key={index}>
                <div className="offer">
                  <div className="imgHodler">
                  {data.fields.rating.value && (<span className="rating">
                      <Text field={data.fields.rating} />
                    </span>
                    )}
                    <div className="img">
                      <Image className="" field={data.fields.image} />
                    </div>
                  </div>
                  <div className="offerDetail">
                    {/* <ul className="tags">
                    {data.fields.offerCategory.length >0 && (<li>
                        <Text field={data.fields.offerCategory[0].fields.DropdownText} />
                      </li>
                    )}
                    </ul> */}
                    {data.fields.heading.value && (<strong className="offerDetail-title">
                      <Text field={data.fields.heading} />
                    </strong>
                   )}
                    {data.fields.cashback.value && (<span className="offerDetail-cashBack">
                      <Text field={data.fields.cashback} />
                    </span>
                   )}
                    {data.fields.duration.value && (<span className="offerDetail-valid">
                      <Text field={data.fields.duration} />
                    </span>
                   )}
                    {data.fields.location.value && (<span className="offerDetail-pin">
                      <Text field={data.fields.location} />
                    </span>
                   )}
                  </div>
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
};
export default Offers;
